import { PacketRequestType } from '../../@types/PacketReqFormData.type';
import newApiClient from '../apiClient';

export const requestAndPrintPacket = async (
  reqData: PacketRequestType,
  accessToken: string,
) => {
  const url = `/jetstream/api/1/requestpacket`;

  const apiClient = newApiClient(accessToken);

  await apiClient.post(url, reqData);
};
